import React, { useEffect, useState } from 'react'
import { Button, Card, Table, Row } from "antd";
import { getIncomingsWithPage } from "../../services/serviceWarehouseIncoming";
import { SearchOutlined } from "@ant-design/icons";
import userDateFormatter from "../../services/formatters/userDateFormatter";
import Filter from "../filterWrapper/Filter";
import WarehouseIncomingFilter from "./WarehouseIncomingFilter";
import WarehouseCreateContainer from './WarehouseCreateContainer';
import { useLocation } from "@reach/router";
import config from '../../config'

const getOneMonthAgo = () => {
    const today = new Date();
    today.setMonth(today.getMonth() - 1);
    return today;
};

const WarehouseIncoming = ({ navigate }) => {
    const location = useLocation();
    const [sortedList, setSortedList] = useState([])
    const [newModal, setNewModal] = useState(false)
    const [openFilter, setOpenFilter] = useState(false)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [filters, setFilters] = useState({
        supplier: "",
        stockName: '',
        endDate: new Date(),
        startDate: getOneMonthAgo(),
        stockDescription: ""
    })

    const baseObj = {
        supplier: "",
        stockName: '',
        endDate: new Date(),
        startDate: getOneMonthAgo(),
        stockDescription: ""
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getWarehouseIncoming(page, pageSize);
    }, [location.search]);

    const getWarehouseIncoming = (page, pageSize, requestObj = filters) => {
        const mockFilters = { ...requestObj };
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;
        getIncomingsWithPage(mockFilters)
            .then(({ data }) => {
                handlers.sortData(data.content)
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
            })
    }

    const toggleFilterDisplay = () => setOpenFilter(!openFilter)

    function handleFilter({ purchaseNo, createdBy, date }) {
        arguments[0].endDate = arguments[0].endDate.hasOwnProperty('_d') ? arguments[0].endDate._d : config.limitDates.max
        arguments[0].startDate = arguments[0].startDate.hasOwnProperty('_d') ? arguments[0].startDate._d : config.limitDates.min

        const requestObj = {}
        Object.keys(arguments[0]).map(key => requestObj[key] = arguments[0][key])
        setFilters(requestObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);

        return new Promise((resolve => resolve(200)))
    }

    const handlers = {
        updater() {
            getWarehouseIncoming(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            const sorted = list.map(incoming => ({
                key: incoming.id,
                id: incoming.id,
                stockCode: incoming.sc || '-',
                stockDescription: incoming.sd || '-',
                supplierCode: incoming.s || '-',
                quantity: incoming.iq,
                creater: incoming.e,
                createdDate: incoming.cd
            }))
            setSortedList(sorted)
        }
    }

    const columns = [
        {
            title: 'İşlem Tarihi',
            key: 'createdDate',
            render: (text, record) => userDateFormatter(record.createdDate)
        },
        {
            title: 'Tedarikçi',
            dataIndex: 'supplierCode',
            key: 'supplierCode'
        },
        {
            title: 'Ürün Kodu',
            dataIndex: 'stockCode',
            key: 'stockCode'
        },
        {
            title: 'Ürün Açıklaması',
            dataIndex: 'stockDescription',
            key: 'stockDescription'
        },
        {
            title: 'İşlemi Yapan',
            dataIndex: 'creater',
            key: 'creater'
        },
        {
            title: 'Adet',
            dataIndex: 'quantity',
            key: 'quantity'
        }
    ];

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    const resetFilters = () => {
        setFilters(baseObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
    };


    return (
        <React.Fragment>
            <Card title={'Depo Giriş'}
                extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}>Yeni Ekle</Button>}>
                <Row justify={"start"}>
                    <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined /></div>
                </Row>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <WarehouseCreateContainer show={newModal} modalCloser={handlers.modalCloser}
                updater={handlers.updater} /> : null
            }
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Depo Giriş'}
                    handler={handleFilter}
                    resetHandler={resetFilters}
                >
                    <WarehouseIncomingFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default WarehouseIncoming